import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import { SchemaType } from '@utils/ValidationSchemas/Index';
import { Schema as MacroSchema } from '@pages/Ui/Payments/Topup/Macro/Validation';

const Schema = (prefixFields: string = ''): SchemaType => {
    const { t } = useTranslation('extraPaymentsUserTopup');
    return {
        ...MacroSchema(false, prefixFields),
        payer: Yup.string()
            .required(
                t('payer.form.errors.validation.required', {
                    defaultValue: 'Laukelis privalomas.',
                }),
            )
            .min(
                3,
                t('payer.form.errors.validation.min', {
                    defaultValue:
                        'Laukelis privalo būti sudarytas mažiausiai iš 3 simbolių.',
                }),
            )
            .max(
                64,
                t('payer.form.errors.validation.max', {
                    defaultValue:
                        'Laukelis gali būti sudarytas daugiausiai iki 64 simbolių.',
                }),
            )
            .matches(
                /^([\w|\d|-|_| ]+)$/u,
                t('payer.form.errors.validation.format', {
                    defaultValue:
                        'Laukelis gali būti sudarytas tik iš raidžių, skaičių, tarpų, brūkšnelių ir pabraukimo ženkliukų.',
                }),
            ),
    };
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const init = (prefixFields?: string) =>
    Yup.object().shape(Schema(prefixFields));

export { init };

export default Schema;
